<div class="section-question">
  @if (isEditing()) {
    <div class="question-config">
      <label class="config-label">
        @if (getQuestionTypeIcon(); as iconInfo) {
          <span class="question-type-icon-wrapper">
            @if (iconInfo.iconType === 'prime') {
              <i [class]="'pi ' + iconInfo.icon" class="question-type-icon"></i>
            }
            @if (iconInfo.iconType === 'material') {
              <span class="material-symbols-outlined question-type-icon">{{ iconInfo.icon }}</span>
            }
          </span>
        }
        Section Label (Optional)
      </label>
      <input
        #labelInput
        type="text"
        class="config-input label-input"
        [value]="question().labelText"
        (input)="onLabelChange($any($event.target).value)"
        [disabled]="disabled()"
        placeholder="Enter section label (optional)">
    </div>
  } @else {
    <div class="question-preview">
      <div class="section-divider-wrapper">
        @if (question().labelText) {
          <span class="section-label" [innerHTML]="sanitizeHtml(question().labelText)"></span>
        }
      </div>
    </div>
  }
</div>

